import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
// import imageToBase64 from "image-to-base64";
import { saveAs } from "file-saver";

//Custom Styles
import {
  Container,
  Buttons,
  CenterAbout,
  HeaderAbout,
  LottieAnimation,
  LottieAnimationDiv,
  ImageDiv,
  P,
  Anchor,
  Div,
  OuterDiv,
  ButtonDiv,
  ButtonImg,
  DivButton,
} from "./FiddleOneStyle";

// Component
import { checkBrowser } from "../../component/commonFunctions";

// Lottie
import thinking from "../../assets/lottieAnimation/Thinking.json";

//values and utils
import { images, images as values } from "../../imageValues";
import {
  AxlTracker,
  generateRandomNumber,
  loadImage,
  playSound,
  randomArtImage,
} from "../../utils";
import stringValues from "../../stringValues";

// Actions
import { randomArtwork } from "../../actions/randomArtworkAction";

// AXL
import { useAxL } from "../../AxLContext";
import AxL from "../../axl";
import { ceilPowerOfTwo } from "three/src/math/MathUtils";

const data = [values.ORIENTATION, values.SHARE, values.DOWNLOAD, values.RELOAD];
const randomNumber = generateRandomNumber(10, 0);

const FiddleOne = ({
  onClick,
  onDownload,
  playPauseSoundState,
  changeLanguageState,
  boardName,
  randomArtwork,
  changeLanguage,
  onClickShare,
  onInformation,
  playPauseSound,
  onInstruction,
  onRestart,
  showInfo
}) => {
  const axl = useAxL();
  const [mobileWidth, setMobileWidth] = useState(window.innerWidth);
  const [randomImage, setRandomImage] = useState("");
  const [showInitial, setShowInitial] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setShowInitial(false);
    }, 3000);
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setMobileWidth(window.innerWidth);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // This is used to select random Board
  useEffect(() => {
    const data = randomArtImage(randomNumber, boardName);
    setRandomImage(data.HD);
    randomArtwork(randomNumber);
  }, [randomNumber]);

  // This is use to share with axl
  const AxlShare = () => {
    axl.sendMessage(AxL.ChildToHost.SHARE, {
      title: stringValues[changeLanguageState.data].buildYourOwnMatchbox,
    });
  };

  const browser = checkBrowser();

  // This is used to download the image
  const download = () => {
    const commonButtonProps = {
      onClick: () => {
        playSound(playPauseSoundState);
        getImage(browser === "browser" ? 1 : 2);
        AxlTracker(axl, "Clicked on Download", "Download Image", 23, true);
      },
      style: {
        backgroundColor: "#E9BE2F",
        height: 40,
        width: 40,
      },
      title: stringValues[changeLanguageState.data].downloadText,
    };
    const buttonContent = <img src={data[2]} alt="ButtonsImage" />;

    if (
      (browser === "browser" && AxL.can.download === true) ||
      (browser === "WebView" && AxL.can.shareFiles === true)
    ) {
      return <Buttons {...commonButtonProps}>{buttonContent}</Buttons>;
    }
  };

  const getImage = async (img) => {
    try {
      const fileName = "collection.jpeg";

      if (img === 1) {
        saveAs(randomImage, fileName);
      } else {
        const base64 = await loadImage(randomImage);
        axl.sendMessage(AxL.ChildToHost.SHARE, {
          title: stringValues[changeLanguageState.data].buildYourOwnMatchbox,
          files: [
            {
              data: base64,
              name: fileName,
              type: "image/jpeg",
            },
          ],
        });
      }
    } catch (error) {
      console.error("Error downloading the image:", error);
    }
  };

  return (
    <>
      <Container>
        {mobileWidth < 1080 && !showInfo &&(
          <OuterDiv>
            <DivButton onClick={() => onInformation()} title="Information">
              <ButtonImg src={images.INFORMATION} />
            </DivButton>
            <DivButton onClick={changeLanguage} title="Language">
              <ButtonImg src={images.LANGUAGE} />
            </DivButton>
            <DivButton onClick={playPauseSound} title="Sound">
              {playPauseSoundState.data ? (
                <ButtonImg src={images.VOLUMEON} />
              ) : (
                <ButtonImg src={images.VOLUMEOOF} />
              )}
            </DivButton>
            <DivButton onClick={onInstruction} title="Instruction">
              <ButtonImg src={images.INSTRUCTION} />
            </DivButton>
            <DivButton onClick={onClickShare} title="Share">
              <ButtonImg src={images.SHAREBUTTON} />
            </DivButton>
            <DivButton onClick={onRestart} title="Restart">
              <ButtonImg src={images.RESTART} />
            </DivButton>
          </OuterDiv>
        )}
        <CenterAbout
          style={{
            width: mobileWidth > 1080 ? 550 : 380,
            height: mobileWidth > 1080 ? "100%" : "80%",
            marginTop: mobileWidth > 1080 ? 90 : 0,
            // backgroundColor:"red"
          }}
        >
          {showInitial ? (
            <>
              <HeaderAbout
                style={{
                  paddingLeft: mobileWidth > 1080 ? 20 : 10,
                  paddingRight: mobileWidth > 1080 ? 20 : 10,
                }}
              >
                {stringValues[changeLanguageState.data].fiddleTitle}
              </HeaderAbout>
              <LottieAnimationDiv>
                <LottieAnimation animationData={thinking} />
              </LottieAnimationDiv>
              <HeaderAbout
                style={{ marginBottom: 200, marginLeft: 20, marginRight: 20 }}
              >
                {stringValues[changeLanguageState.data].loading} <br />
                {stringValues[changeLanguageState.data].artwork}
              </HeaderAbout>
            </>
          ) : (
            <>
              <HeaderAbout
                style={{
                  paddingLeft: mobileWidth > 1080 ? 20 : 10,
                  paddingRight: mobileWidth > 1080 ? 20 : 10,
                }}
              >
                {stringValues[changeLanguageState.data].fiddleTitle}
              </HeaderAbout>
              <ImageDiv>
                <img
                  src={randomImage}
                  alt="fiddleFrontImage"
                  style={{
                    width: mobileWidth > 1080 ? 500 : 320,
                    maxHeight: mobileWidth > 1080 ? 500 : 320,
                    objectFit: "contain",
                  }}
                />
              </ImageDiv>
              <Div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    gap: 20,
                  }}
                >
                  {download()}
                  {/* {AxL.can.download === true && download()} */}
                  <Buttons
                    onClick={() => {
                      playSound(playPauseSoundState);
                      AxlTracker(
                        axl,
                        "Clicked Share button",
                        "Sharing Image",
                        24,
                        true
                      );
                      AxlShare();
                    }}
                    style={{
                      backgroundColor: "#E9BE2F",
                      height: 40,
                      width: 40,
                    }}
                    title="Share"
                  >
                    <img src={data[1]} alt="ButtonsImage" />
                  </Buttons>
                </div>
                <Buttons
                  onClick={onClick}
                  style={{
                    color: "white",
                    backgroundColor: "#E9BE2F",
                    height: 40,
                    width: 160,
                    marginTop: 10,
                    marginBottom: 15,
                    fontWeight: "bold",
                    color: "#89202b",
                  }}
                >
                  {stringValues[changeLanguageState.data].continueCollecting}
                </Buttons>
                <P>
                  <Anchor
                    // target="_blank"
                    // href={
                    //   "https://artsandculture.google.com/story/a-little-box-of-lights-tasveer-ghar/yQUxmdhlde8AJw?hl=en"
                    // }
                    onClick={() => {
                      AxlTracker(
                        axl,
                        "Clicked on Google Arts and Culture",
                        "About = Google Arts and Culture",
                        3,
                        true
                      );
                      axl.sendMessage(
                        AxL.ChildToHost.NAVIGATE,
                        "https://artsandculture.google.com/story/a-little-box-of-lights-tasveer-ghar/yQUxmdhlde8AJw?hl=en"
                      );
                    }}
                  >
                    {stringValues[changeLanguageState.data].creditMessage}
                  </Anchor>
                </P>
              </Div>
            </>
          )}
        </CenterAbout>
      </Container>
    </>
  );
};

const mapStateToProps = (state) => ({
  playPauseSoundState: state.playPauseSound,
  changeLanguageState: state.changeLanguage,
  randomArtworkState: state.randomArtwork,
});

const mapDispatchToProps = (dispatch) => ({
  randomArtwork: (params) => dispatch(randomArtwork(params)),
});

export default connect(mapStateToProps, mapDispatchToProps)(FiddleOne);
